// Configuração centralizada das URLs das Cloud Functions
// Mantém apenas endpoints que ainda usam Cloud Functions

// Base URL das Cloud Functions
const FUNCTIONS_BASE_URL = import.meta.env.VITE_FUNCTIONS_BASE_URL;

if (!FUNCTIONS_BASE_URL) {
  console.error(
    "[API Config] VITE_FUNCTIONS_BASE_URL não está definida no .env!",
    "Configure a variável de ambiente com a URL das Cloud Functions."
  );
}

// Endpoints das Cloud Functions (apenas os que ainda precisam de backend)
export const API_ENDPOINTS = {
  // Devocional (usa API externa via Cloud Function)
  getDevocionalDiario: `${FUNCTIONS_BASE_URL}/get_devocional_diario`,

  // Notificações (requer server-side para enviar push)
  sendPushNotification: `${FUNCTIONS_BASE_URL}/send_push_notification`,

  // Bíblia (proxy para YouVersion API)
  bibliaProxy: `${FUNCTIONS_BASE_URL}/biblia_proxy`,
};

export default API_ENDPOINTS;
